var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.mode === 'pc')?_c('div',{class:_setup.buttonClass,on:{"click":_setup.handleScrollToTop}},[_c('SvgIcons',{staticClass:"c-action-svg",attrs:{"name":"icon_top"}}),_c('span',{staticClass:"action-block-span"},[_vm._v(_vm._s(_vm.$t('enterprise.top')))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }